import FirstNameMinimalStep from '@/pages/members/pages/Onboarding/steps/FirstNameMinimalStep';

import GetAccessToV2 from '../../components/shared/GetAccessToV2';
import { OnboardingNodeType, OnboardingStepType } from '../../steps/types';
import { OnboardingNode } from '../../types';

export const FIRST_NAME_NODE: OnboardingNode = {
  index: 0,
  key: OnboardingNodeType.FIRST_NAME,
  options: { countsTowardProgressBar: false, hideProgressBar: true },
  elements: [
    {
      uid: OnboardingStepType.FIRST_NAME,
      component: (
        <FirstNameMinimalStep
          uid={OnboardingStepType.FIRST_NAME}
          nodeType={OnboardingNodeType.FIRST_NAME}
          displayName="Name & Email"
          actionButtonText="Continue"
        />
      ),
      additionalContent: (
        <GetAccessToV2
          headingKey="telehealthFromYourSmartphone"
          imageAltKey="affectAppScreensTelehealth"
          imageSrc="/images/onboarding/Home-1on1-Points-3up.png"
          listItemKeys={[
            'oneOnOneSupportAndMessaging',
            'realRewardsForRealProgress',
            'medicationsForSymptoms',
            'dailyChallengesAndProgressTracking',
            'supportInsideAndOutsideOfTreatment'
          ]}
        />
      )
    }
  ]
};
